/**
 * The app's content area, guarded: a page that fails shows its screen where
 * the page was, and the sidebar and top bar keep working. Following any link
 * clears it, and so does "Try again".
 *
 * A pathless layout route inside `AppLayout` (app.tsx), so every page is under it.
 */
import { Outlet, useLocation } from "react-router-dom";
import { ErrorBoundary } from "./error-boundary";
import { ErrorScreen, ReloadingScreen } from "./error-fallback";

export function ContentBoundary() {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary
      resetKeys={[pathname]}
      reloading={<ReloadingScreen size="content" />}
      fallback={(props) => <ErrorScreen size="content" {...props} />}
    >
      <Outlet />
    </ErrorBoundary>
  );
}
